module.exports = __webpack_public_path__ + "static/10-issue-minimization-automated-testing-db535de87e6f835dbfa647c33fd2e94e.jpg";